<style>
	.fc-resource-area td.fc-widget-content > div:first-of-type {
		height:18px;
	}

	.fc-resource-area td.fc-widget-content .fc-cell-content {
		padding: 0px;
	}

	.fc-time-area .fc-widget-content > div:first-of-type {
		height:18px;
	}
</style>

<template>
	<div class="row">
        <div class="col-sm-12">
            <div class="ibox">
                <div class="ibox-content">
                    <h2>Schedule</h2>

                    <div id="calendar"></div>
                   

                </div>
            </div>
        </div>   
   	</div>
</template>

<script>

    export default {
        data: function () {
            return {
                projects: [],
                current_page: 0,
                totalProjects: 0,
                loading: true,
                search_string: '',
                searching: false
            }
        },
        mounted: function() {

        	$('#calendar').fullCalendar({
        	schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
			now: '2016-03-01',
			editable: true,
			aspectRatio: 1.8,
			scrollTime: '00:00',
			header: {
				left: 'today prev,next',
				center: 'title',
				right: 'timelineDay,timelineThreeDays,agendaWeek,month'
			},
			defaultView: 'timelineProject',
			views: {
		        timelineProject: {
		            type: 'timeline',
		            duration: { days: 100 },
		            buttonText: '4 day'
		        }
		    },
		    slotLabelFormat: [
		    	'MMMM',
			    'D'
			],
			slotDuration: {day: 1},
			resourceGroupField: 'building',
			resources: [
				{ id: '1', title: 'Stage 1'},
				{ id: '2', title: '    Planning for sprint 1'},
				{ id: '3', title: '    Sprint 1'},
				{ id: '4', title: '        Review'},
				{ id: '5', title: '        Retrospective'},
				{ id: '6', title: '    Planning for sprint 2'},
				{ id: '7', title: '    Sprint 2'},
				{ id: '8', title: '        Review'},
				{ id: '9', title: '        Retrospective'}
			],
			events: [
				{ id: '1', resourceId: '1', start: '2016-02-29', end: '2016-04-07', title: '' },
				{ id: '2', resourceId: '2', start: '2016-02-29', end: '2016-02-29', title: '' },
				{ id: '3', resourceId: '3', start: '2016-03-01', end: '2016-03-15 17:00:00', title: '' },
				{ id: '4', resourceId: '4', start: '2016-03-15', end: '2016-03-15', title: '' },
				{ id: '5', resourceId: '5', start: '2016-03-15', end: '2016-03-15', title: '' },
				{ id: '6', resourceId: '6', start: '2016-03-16', end: '2016-03-16', title: '' },
				{ id: '6', resourceId: '6', start: '2016-03-17', end: '2016-03-31', title: '' }
			],
			resourceRender: function (event, element) {
			    element.find('span.fc-cell-text').html(element.find('span.fc-cell-text').text());
			}
		});


        }
    }
</script>